module.exports = __webpack_public_path__ + "img/pdf-download-inactive.b91f421b.svg";